import { Card, DatePicker, Drawer, Form, Select, Space } from 'antd';
import { FC } from 'react';
import CultureSelect from 'app/components/Select/CultureSelect/CultureSelect';
import NumberInput from 'app/components/NumberInput/NumberInput';
import { useRoutesWithoutTaskFiltersCard } from './hooks/useRoutesWithoutTaskFiltersCard';

interface IProps {}

const RoutesWithotTaskFiltersCard: FC<IProps> = () => {
  const {
    onClose,
    t,
    form,
    onFormChange,
    onOpen,
    isOpen,
    options,
    values,
    transportOptions,
    isTransportLoading,
    onFilterDeselect,
  } = useRoutesWithoutTaskFiltersCard();

  return (
    <>
      <Card style={{ marginBottom: 12 }}>
        <Select
          style={{ width: '100%' }}
          // TODO: search icon
          // prefixIcon={<SearchOutlined />}
          onClick={onOpen}
          placeholder={t('Common.Filters', 'Filters')}
          mode="multiple"
          options={options}
          value={values}
          onDeselect={onFilterDeselect}
          open={false}
        />
      </Card>
      <Drawer
        title={t('Common.Filters', 'Filters')}
        visible={isOpen}
        forceRender={true}
        onClose={onClose}
        destroyOnClose
        placement="left"
        width={346}
      >
        <Form
          layout={'vertical'}
          form={form}
          initialValues={{ layout: 'vertical' }}
          requiredMark="optional"
          id={'routesFiltersFormId'}
          onFieldsChange={onFormChange}
        >
          <Form.Item name="date">
            <DatePicker.RangePicker
              style={{ width: '100%' }}
              allowClear
              allowEmpty={[true, true]}
            />
          </Form.Item>

          <Space>
            <Form.Item name="durationFrom">
              <NumberInput
                disabled
                placeholder={t('Task.DurationFrom', 'Duration from (min)')}
              />
            </Form.Item>

            <Form.Item name="durationTo">
              <NumberInput
                disabled
                placeholder={t('Task.DurationTo', 'Duration to (min)')}
              />
            </Form.Item>
          </Space>

          <Form.Item name="gpsVehicleIds">
            <Select
              mode="multiple"
              bordered={true}
              placeholder={t('Transport.TransportModel', 'Transport model')}
              dropdownMatchSelectWidth={false}
              options={transportOptions}
              loading={isTransportLoading}
              allowClear
            />
          </Form.Item>

          <Form.Item name="cultureIds">
            <CultureSelect allowClear={true} mode="multiple" />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default RoutesWithotTaskFiltersCard;
